<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="sales"
          :title="title"
          :url="url"
          :columns="columns"
          :filter="filter"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-view="onClickView"
          :on-click-delete="onClickDelete"
          :button-view="false"
          aria-sort=""
          :onDataUpdate="onDataUpdate"
          :on-click-export="onClickExport"
          :action-width="180"
        >
          <!-- Filter toolbar -->
          <template v-slot:action>
            <v-col md="3">
              <v-autocomplete
                label="Member"
                required dense outlined
                v-model="filterMember"
                :items="listMembers"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              />
            </v-col>
            <v-col md="3">
              <v-autocomplete
                label="Fitness Consultant"
                required dense outlined
                v-model="filterFitnessConsultant"
                :items="listFitnessConsultants"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              />
            </v-col>
            <v-col md="3">
              <v-autocomplete
                label="Personal Trainer"
                required dense outlined
                v-model="filterPersonalTrainer"
                :items="listPersonalTrainers"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              />
            </v-col>
            <v-col md="3">
              <v-select
                label="Status Pembayaran"
                required dense outlined
                v-model="filterStatusPayment"
                :items="listStatusPayment"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              />
            </v-col>
            <v-col md="3">
              <v-select
                label="Status Verifikasi"
                required dense outlined
                v-model="filterStatus"
                :items="listStatus"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              />
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Dibuat Dari"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterDate"
              />
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Dibuat Sampai"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterDateEnd"
              />
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Last Payment Dari"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterDateLastPayment"
              />
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Last Payment Sampai"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterDateLastPaymentEnd"
              />
            </v-col>
            <v-col md="3">
              <v-checkbox
                label="Hanya Member Sudah Expired"
                v-model="filterExpiredOnly"
                hide-details="true"
                dense
              />
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Expired Dari"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterExpiredDateStart"
                :disabled="filterExpiredOnly"
              />
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Expired Sampai"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterExpiredDateEnd"
                :disabled="filterExpiredOnly"
              />
            </v-col>
          </template>

          <!-- Chip status -->
          <template v-slot:[`item.status`]="{ item }">
            <div class="py-0">
              <v-chip
                v-if="item.status === 'verified'"
                color="#4CAF50" small text-color="white"
              >{{ item.status }}</v-chip>
              <v-chip
                v-else-if="item.status === 'unverified'"
                color="#FFC107" small text-color="white"
              >{{ item.status }}</v-chip>
            </div>
          </template>

          <!-- Chip status payment -->
          <template v-slot:[`item.status_payment`]="{ item }">
            <div class="py-0">
              <v-chip
                v-if="item.status_payment === 'paid' || item.status_payment === 'dp'"
                color="#4CAF50" small text-color="white"
              >{{ item.status_payment }}</v-chip>
              <v-chip
                v-else-if="item.status_payment === 'unpaid'"
                color="#FD397A" small text-color="white"
              >{{ item.status_payment }}</v-chip>
            </div>
          </template>

          <!-- Formatting angka -->
          <template v-slot:[`item.price_sales`]="{ item }">
            <div>Rp {{ new Intl.NumberFormat("id-ID").format(item.price_sales) }}</div>
          </template>
          <template v-slot:[`item.total_payment`]="{ item }">
            <div>Rp {{ new Intl.NumberFormat("id-ID").format(item.total_payment) }}</div>
          </template>
          <template v-slot:[`item.remaining_payment`]="{ item }">
            <div>Rp {{ new Intl.NumberFormat("id-ID").format(item.remaining_payment) }}</div>
          </template>

          <!-- Tanggal -->
          <template v-slot:[`item.created_at`]="{ item }">
            <div v-if="item.created_at != null">
              {{ item.created_at | moment("DD/MM/YYYY HH:mm:ss") }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:[`item.verified_at`]="{ item }">
            <div v-if="item.verified_at != null">
              {{ item.verified_at | moment("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
          </template>

          <!-- PENANDA untuk menyembunyikan aksi bawaan per baris -->
          <template slot="item.action" slot-scope="{ item }">
            <!-- Jika mau tampilkan VIEW kustommu sendiri, letakkan di atas penanda -->
            <!-- <v-btn small rounded depressed color="success" dark class="mr-2" @click="onClickView(item)">VIEW</v-btn> -->
            <span
              v-if="item?.status === 'verified' && !hasVerification"
              class="action-hide-guard"
            />
          </template>
        </datatable>
      </div>
    </div>

    <delete-dialog ref="delete" url="sales" :success="deleteSuccess" />
    <verified-dialog ref="verified" url="sales" :success="deleteSuccess" />
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import VerifiedDialog from "@/view/component/VerifiedDialog.vue";
import router from "@/router";
import Moment from "moment";
import ApiService from "@/core/services/api.service";
import JwtService from "../../../../core/services/jwt.service";

export default {
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Sales", route: "" },
      { title: "Sales" },
    ]);
    this.filterBy();
    const members = await ApiService.get("user/list?role_slug=member");
    this.listMembers = members.data;
    const fitnessConsultants = await ApiService.get(
      "user/list?role_slug=fitness-consultant"
    );
    this.listFitnessConsultants = fitnessConsultants.data;
    const personalTrainers = await ApiService.get(
      "user/list?role_slug=personal-trainer"
    );
    this.listPersonalTrainers = personalTrainers.data;

    this.listStatusPayment = [
      { id: "paid", name: "Lunas" },
      { id: "dp", name: "DP" },
      { id: "unpaid", name: "Belum Lunas" },
    ];
    this.listStatus = [
      { id: "verified", name: "Verified" },
      { id: "unverified", name: "Unverified" },
    ];
  },
  data() {
    return {
      title: "Sales",
      url: "sales/data",
      filterMember: null,
      filterFitnessConsultant: null,
      filterPersonalTrainer: null,
      filterStatusPayment: null,
      listMembers: [],
      listFitnessConsultants: [],
      listPersonalTrainers: [],
      listStatusPayment: [],
      listStatus: [],
      filterStatus: null,
      filterDate: null,
      filterDateEnd: null,
      filterDateLastPayment: null,
      filterDateLastPaymentEnd: null,
      filterExpiredOnly: false,
      filterExpiredDateStart: null,
      filterExpiredDateEnd: null,
      filter: null,
      columns: [
        { value: "id" },
        { text: "Kode Transaksi", value: "code", sortable: true, searchable: true },
        { text: "Nama Member", value: "member_name", sortable: true, searchable: true },
        { text: "Status Pembayaran", value: "status_payment", sortable: true, searchable: true },
        { text: "Status Verifikasi", value: "status", sortable: true, searchable: false },
        { text: "Tanggal Verifikasi", value: "verified_at", sortable: true, searchable: false },
        { text: "Tanggal Pembayaran Terakhir", value: "last_payment_date", sortable: true, searchable: false },
        { text: "Total Harga", value: "price_sales", sortable: true, searchable: false },
        { text: "Total Pembayaran", value: "total_payment", sortable: true, searchable: false },
        { text: "Sisa Pembayaran", value: "remaining_payment", sortable: true, searchable: false },
      ],
      buttonView: false,
    };
  },
  computed: {
    hasVerification() {
      // permission "verification" pada modul sales
      return this.$store.getters.hasPermission("sales", "verification");
    }
  },
  methods: {
    onClickCreate() {
      // router.push({ name: "tambah-sales" });
      const { href } = router.resolve({
          name: "tambah-sales",
        });
        window.open(href, "_blank");
    },
    onClickUpdate(item) {
      // Guard ekstra: jika verified & bukan verifier, tahan
      if (item?.status === "verified" && !this.hasVerification) {
        this.$swal.fire({
          icon: "info",
          title: "Tidak Diizinkan",
          text: "Data yang sudah diverifikasi tidak dapat diubah oleh akun Anda.",
          showConfirmButton: true
        });
        return;
      }
      const { href } = router.resolve({
          name: "edit-sales",
          params: { id: item.id },
        });
        window.open(href, "_blank");
      // router.push({ name: "edit-sales", params: { id: item.id } });
    },
    onClickView(item) {
      router.push({ name: "lihat-sales", params: { id: item.id } });
    },
    onClickDelete(item) {
      // Guard ekstra: jika verified & bukan verifier, tahan
      if (item?.status === "verified" && !this.hasVerification) {
        this.$swal.fire({
          icon: "info",
          title: "Tidak Diizinkan",
          text: "Data yang sudah diverifikasi tidak dapat dihapus oleh akun Anda.",
          showConfirmButton: true
        });
        return;
      }
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
    formattedPrice() {
      return new Intl.NumberFormat("id-ID").format(this.harga);
    },
    filterBy() {
      let finalFilter = [];

      if (this.filterMember) {
        finalFilter = [...finalFilter, { column: "member_id", value: this.filterMember }];
      }
      if (this.filterFitnessConsultant) {
        finalFilter = [...finalFilter, { column: "fitness_consultant_id", value: this.filterFitnessConsultant }];
      }
      if (this.filterPersonalTrainer) {
        finalFilter = [...finalFilter, { column: "personal_trainer_id", value: this.filterPersonalTrainer }];
      }
      if (this.filterStatusPayment) {
        finalFilter = [...finalFilter, { column: "status_payment", value: this.filterStatusPayment }];
      }
      if (this.filterStatus) {
        finalFilter = [...finalFilter, { column: "status", value: this.filterStatus }];
      }
      if (this.filterDate) {
        finalFilter = [
          ...finalFilter,
          {
            column: "created_at",
            value: Moment(this.filterDate, "DD/MM/YYYY").startOf("day").format("YYYY-MM-DD HH:mm:ss"),
            operator: "gte",
          },
        ];
      }
      if (this.filterDateEnd) {
        finalFilter = [
          ...finalFilter,
          {
            column: "created_at",
            value: Moment(this.filterDateEnd, "DD/MM/YYYY").endOf("day").format("YYYY-MM-DD HH:mm:ss"),
            operator: "lte",
          },
        ];
      }

      if (this.filterDateLastPayment) {
        finalFilter = [
          ...finalFilter,
          {
            column: "last_payment_date",
            value: Moment(this.filterDateLastPayment, "DD/MM/YYYY").startOf("day").format("YYYY-MM-DD HH:mm:ss"),
            operator: "gte",
          },
        ];
      }
      if (this.filterDateLastPaymentEnd) {
        finalFilter = [
          ...finalFilter,
          {
            column: "last_payment_date",
            value: Moment(this.filterDateLastPaymentEnd, "DD/MM/YYYY").endOf("day").format("YYYY-MM-DD HH:mm:ss"),
            operator: "lte",
          },
        ];
      }

      // Filter: member yang sudah expired (expired_date <= hari ini)
      if (this.filterExpiredOnly) {
        finalFilter = [
          ...finalFilter,
          { column: "expired_date_end", value: Moment().format("YYYY-MM-DD") },
        ];
      } else {
        if (this.filterExpiredDateStart) {
          finalFilter = [
            ...finalFilter,
            {
              column: "expired_date_start",
              value: Moment(this.filterExpiredDateStart, "DD/MM/YYYY").format("YYYY-MM-DD"),
            },
          ];
        }
        if (this.filterExpiredDateEnd) {
          finalFilter = [
            ...finalFilter,
            {
              column: "expired_date_end",
              value: Moment(this.filterExpiredDateEnd, "DD/MM/YYYY").format("YYYY-MM-DD"),
            },
          ];
        }
      }

      this.filter = finalFilter.length > 0 ? finalFilter : null;
    },
    async onClickExport() {
      try {
        const token = JwtService.getToken();
        if (!token) return;

        const params = {};

        // === Jadikan semua filter opsional ===
        if (this.filterMember) params.member_id = this.filterMember;
        if (this.filterFitnessConsultant) {
          params.fitness_consultant_id = this.filterFitnessConsultant;
        }
        if (this.filterPersonalTrainer) {
          params.personal_trainer_id = this.filterPersonalTrainer;
        }
        if (this.filterStatusPayment) params.status_payment = this.filterStatusPayment;
        if (this.filterStatus) params.status = this.filterStatus;

        if (this.filterDate) {
          params.created_at_start = Moment(this.filterDate, "DD/MM/YYYY")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        }
        if (this.filterDateEnd) {
          params.created_at_end = Moment(this.filterDateEnd, "DD/MM/YYYY")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        }

        if (this.filterDateLastPayment) {
          params.last_payment_start = Moment(this.filterDateLastPayment, "DD/MM/YYYY")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        }
        if (this.filterDateLastPaymentEnd) {
          params.last_payment_end = Moment(this.filterDateLastPaymentEnd, "DD/MM/YYYY")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        }

        // Filter: member yang sudah expired (expired_date <= hari ini)
        if (this.filterExpiredOnly) {
          params.expired_date_end = Moment().format("YYYY-MM-DD");
        } else {
          if (this.filterExpiredDateStart) {
            params.expired_date_start = Moment(this.filterExpiredDateStart, "DD/MM/YYYY").format("YYYY-MM-DD");
          }
          if (this.filterExpiredDateEnd) {
            params.expired_date_end = Moment(this.filterExpiredDateEnd, "DD/MM/YYYY").format("YYYY-MM-DD");
          }
        }

        const queryString = new URLSearchParams({
          token,
          ...params,
        }).toString();

        const url = `${process.env.VUE_APP_SERVER_URL}/sales/export?${queryString}`;
        window.open(url, "_blank");
      } catch (e) {
        this.$swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal mengunduh report sales. " + (e.message || ""),
          showConfirmButton: true,
        });
      }
    }

  },
  watch: {
    filterMember() { this.filterBy(); },
    filterFitnessConsultant() { this.filterBy(); },
    filterPersonalTrainer() { this.filterBy(); },
    filterStatusPayment() { this.filterBy(); },
    filterStatus() { this.filterBy(); },
    filterDate() { this.filterBy(); },
    filterDateEnd() { this.filterBy(); },
    filterDateLastPayment() { this.filterBy(); },
    filterDateLastPaymentEnd() { this.filterBy(); },
    filterExpiredOnly() { this.filterBy(); },
    filterExpiredDateStart() { this.filterBy(); },
    filterExpiredDateEnd() { this.filterBy(); },
  },
  components: {
    Datatable,
    DeleteDialog,
    VerifiedDialog,
  },
};
</script>

<style scoped>
/* Sembunyikan semua konten aksi bawaan (menu/tombol) setelah “penanda” */
::v-deep td .action-hide-guard ~ * {
  display: none !important;
}
</style>
